<template>
    <div>
        <Nav currentpath="/teaching">
            <div id="teachingmain">
                <h1>Teachings</h1>
                <div class="teachingyear" v-for="(year,i) in teachings" :key="`${i}-${year}`">
                    <h2>{{year.year}}</h2>
                    <div class="teachelt" v-for="(course, i) in year.items" :key="`${i}-${course.title}`">
                        <b>{{course.title}} [{{course.class}}, {{course.hours}} hours]</b><a :href="course.link">LINK</a>
                        <br/>({{course.text}})
                    </div>
                </div>
                <h1>Advising experience</h1>
                <div class="student" v-for="s in students" :key="`${s.name}-${s.date}`">
                    <h3>{{s.name}}</h3>
                    <div class="studentblock">
                        <b>{{s.date}}</b>{{s.note}}<br/>
                        <i>{{s.topic}}</i>
                    </div>
                </div>
            </div>
        </Nav>
    </div>
</template>

<script>
import Nav from "../../components/Nav.vue"

export default {
    name: 'Teaching',
    components: {Nav},
    data() {
        return {
            students: [
                {
                    'name': 'Abdel-Malik Bouhassoun',
                    'date': 'June - Aug 2018',
                    'note': '[M1] Co-advised with Vincent Jost',
                    'topic': 'On hypergraph ordering problems'
                },
                {
                    'name': 'Abdel-Malik Bouhassoun',
                    'date': 'Feb - July 2019',
                    'note': '[M2] Co-advised with Vincent Jost',
                    'topic': 'Generic tree search algorithms and the Sequential Ordering Problem'
                },
                {
                    'name': 'Paul Revenant',
                    'date': 'June - July 2019',
                    'note': '[L3] Co-advised with Vincent Jost',
                    'topic': 'Longest chains in divisibility graphs'
                },
                {
                    'name': 'Aurélien Secardin',
                    'date': 'Feb - July 2020',
                    'note': '[M2] Co-advised with Vincent Jost',
                    'topic': 'Anytime tree search algorithms for the longest common subsequence problem'
                },
                {
                    'name': 'Pablo Andres Focke',
                    'date': 'May - July 2020',
                    'note': '[L3] Co-advised with Vincent Jost',
                    'topic': 'Iterative beam search algorithms for the permutation flowshop problem'    
                }
            ],
            teachings: [
                {
                    'year': "2019-2020",
                    'items': [
                        {
                            'title': 'Advanced Methods in Operations Research (course project)',
                            'class': 'M2 ORCO', 'hours': '12', 'link': 'https://caseine.org/enrol/index.php?id=339',
                            'text': 'Project designer'
                        },
                        {
                            'title': 'Second year Specialty project',
                            'class': 'Ensimag 2A', 'hours': '15',
                            'link': 'https://ensiwiki.ensimag.fr/index.php?title=Projet_de_sp%C3%A9cialit%C3%A9_-_Exp%C3%A9rimentation_de_m%C3%A9thodes_de_r%C3%A9solution_pour_l%27optimisation_combinatoire',
                            'text': 'Project designer'
                        },
                        {
                            'title': 'Introduction to Operations Research (in french)',
                            'class': 'M1 INFO', 'hours': '12', 'link': 'https://caseine.org/course/view.php?id=42&username=guest',
                            'text': 'Teaching assistant'
                        },
                    ]
                },
                {
                    'year': "2018-2019",
                    'items': [
                        {
                            'title': 'Introduction to graph theory (in french)', 'class': 'L2 INFO', 'hours': '30', 'link': 'https://pagesperso.g-scop.grenoble-inp.fr/~stehlikm/',
                            'text': 'Teaching assistant'
                        },
                        {
                            'title': 'Introduction to software engineering (in french)', 'class': 'L2 INFO', 'hours': '33', 'link': 'https://enseignement.gricad-pages.univ-grenoble-alpes.fr/inf304/',
                            'text': 'Teaching assistant'
                        }
                    ]
                },
                {
                    'year': "2017-2018",
                    'items': [
                        {
                            'title': 'Introduction to computer networks (in french)', 'class': 'M1 INFO', 'hours': '33', 'link': 'http://lig-membres.imag.fr/sicard/CoursRes.html',
                            'text': 'Teaching assistant'
                        },
                        {
                            'title': 'Modelization and data structures (in french)', 'class': 'L1 INFO', 'hours': '30', 'link': 'http://lig-membres.imag.fr/loiseapa/courses/inf202/accueil/index.html',
                            'text': 'Teaching assistant'
                        }
                    ]
                }   
            ]
        }
    }
}
</script>

<style lang="scss">
#teachingmain {
    padding: 10px;
}

.teachelt {
    margin-bottom: 20px;
    b {
        margin-right: 10px;
    }
}

.teachingyear {
    margin-bottom: 30px;
}

.student {
    margin-bottom: 50px;

    .studentblock {
        border-left: 5px solid #ddd;
        padding-left: 30px;
        
        b {
            margin-right: 10px;
        }
    }
}
</style>
